import { Container } from '@plone/components';
import type { Content } from '@plone/types';
import { defineMessages, useIntl } from 'react-intl';
import GridTemplate from '@kitconcept/volto-light-theme/components/Blocks/Listing/GridTemplate';

const messages = defineMessages({
  relatedItems: {
    id: 'Related Items',
    defaultMessage: 'Related Items',
  },
});

const RelatedItems = ({ content }: { content: Content }) => {
  const intl = useIntl();
  const items = content?.relatedItems || [];

  return (
    items?.length > 0 && (
      <Container narrow className="related-items">
        <h2>{intl.formatMessage(messages.relatedItems)}</h2>
        <div className="blocks-group-wrapper default">
          <div className="block listing grid">
            <GridTemplate items={items} />
          </div>
        </div>
      </Container>
    )
  );
};

export default RelatedItems;
